import { withInstall } from "../utils/index.mjs";
import _Loading from "./Loading.mjs";
const Loading = withInstall(_Loading);
var stdin_default = Loading;
export {
  Loading,
  stdin_default as default
};
